const GREY = {
  100: "#474747",
  500: "#f5f5f5",
  600: "#EDEFF3",
  700: "#C5C5C5",
  750: "#b5b5b5",
  800: "#757575",
  900: "#F0F0F0",
};

const PRIMARY = {
  lighter: GREY[200],
  light: GREY[500],
  main: GREY[100],
  dark: GREY[700],
  darker: GREY[950],
};

const SECONDARY = {
  main: "#ffffff",
  grey: GREY[600],
  grey2: GREY[700],
  grey3: GREY[800],
  grey4: GREY[900],
  grey5: GREY[500],
  grey6: GREY[750],
  error: "#d32f2f",
  success: "#2e7d32",
  black: "#1D2433",
};

export const PRIME = "#c85432";
export const BLUE_PRIME = "#044c7a";
export const SECOND_BLUE_RPIME = "linear-gradient(135deg, #e3f2fd, #f8fbff)";
const palette = {
  common: { black: "#000000", white: "#ffffff" },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  prime: PRIME,
  blue_prime: BLUE_PRIME,
  second_blue_prime: SECOND_BLUE_RPIME,
  action: {
    onHover: GREY[600],
    focusBorderOpacity: GREY[600_20],
  },
};

export default palette;
